import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useQuery, gql } from '@apollo/client';

const GET_AGENCY_INFO = gql`
  query GetAgencyInfo($subdomain: String!) {
    agencyPageData(subdomain: $subdomain) {
      name
      logo
    }
  }
`;

export const useAgencyInfo = () => {
  const location = useLocation();
  const isAgencyById = /^\/agence\/\d+$/.test(location.pathname);

  const getSubdomain = (hostname: string): string => {
    const parts = hostname.split('.');
    if (hostname === 'localhost' || hostname.includes('127.0.0.1') || /^\d+\.\d+\.\d+\.\d+$/.test(hostname)) {
      return parts[0] || '';
    }
    if (parts[0] === 'www' && parts.length > 2) {
      return parts[1] || '';
    }
    return parts[0] || '';
  };

  const subdomain = getSubdomain(window.location.hostname);

  const { data, loading, error } = useQuery(GET_AGENCY_INFO, {
    variables: { subdomain },
    skip: isAgencyById || !subdomain || subdomain === 'www' || subdomain === 'ziyara',
  });

  useEffect(() => {
    if (data?.agencyPageData) {
      // Mettre à jour le titre
      document.title = `${data.agencyPageData.name}`;
      
      // Mettre à jour le favicon si un logo est disponible
      if (data.agencyPageData.logo) {
        const favicon = document.getElementById('agency-favicon') as HTMLLinkElement;
        if (favicon) {
          favicon.href = data.agencyPageData.logo;
        }
      }
    }
  }, [data]);

  return {
    agencyInfo: data?.agencyPageData,
    loading,
    error,
  };
}; 